module.exports = __webpack_public_path__ + "img/green_s.aacdad00.svg";